// Simple machine formulas. Friction is ignored everywhere (and the game says so).

/** torque about the fulcrum */
export function torque(weight: number, distance: number): number { return weight * distance; }

/** effort needed at distance d2 to balance a load W at distance d1 */
export function leverEffort(W: number, d1: number, d2: number): number { return (W * d1) / d2; }

/** push needed to hold a crate on a frictionless ramp */
export function rampForce(W: number, angleDeg: number): number { return W * Math.sin((angleDeg * Math.PI) / 180); }

/** ramp length to reach a height at an angle */
export function rampLength(height: number, angleDeg: number): number { return height / Math.sin((angleDeg * Math.PI) / 180); }

/** pull needed with n supporting rope segments */
export function pulleyPull(W: number, segments: number): number { return W / segments; }

/** rope pulled to lift a load by `height` with n segments */
export function pulleyRope(height: number, segments: number): number { return height * segments; }

/** force at the wheel rim to turn an axle load */
export function wheelAxleForce(W: number, rWheel: number, rAxle: number): number { return (W * rAxle) / rWheel; }

/** work = force x distance, the same for every machine in an ideal world */
export function work(force: number, distance: number): number { return force * distance; }
